// Module
var code = `<div class="dropdown_test_wrapper"> <div class="dropdown_background"> </div> <div class="dropdown_options"> <span class="dropdown_none_label">No options</span> </div> </div>`;
// Exports
export default code;